import ChildTemplate from '../_/ChildTemplate';

let el = null;

export default class extends ChildTemplate {
  loading = false;

  href(url) {
    this.loading = true;
    const newUrl = url.replace(/https:\/\/(.)*mag.travel/, '');
    return new Promise((resolve) => {
      if (el) {
        el.remove();
      }
      el = document.createElement('iframe');

      el.src = newUrl;
      el.style.display = 'none';
      el.onload = () => {
        this.loading = false;
        el.contentWindow.print();
        el.contentWindow.onafterprint = () => {
          resolve();
        };
      };
      document.body.appendChild(el);
    });
  }
}
